/* eslint-disable */
import { RINGS_TYPE } from '@ringcentral-integration/commons/modules/RingtoneConfiguration/const';
export default {
  [RINGS_TYPE.Phone_Ring1]: '전화 벨소리 1',
  [RINGS_TYPE.Phone_Ring2]: '전화 벨소리 2',
  [RINGS_TYPE.Acoustic_Dreams]: '어쿠스틱 드림',
  [RINGS_TYPE.Air_Raid]: '공습 경보음',
  [RINGS_TYPE.Allusive]: '암시적 느낌의 소리',
  [RINGS_TYPE.Attention]: '주의',
  [RINGS_TYPE.Blub_Blub]: '우는 소리',
  [RINGS_TYPE.Buzzy]: '윙윙 소리',
  [RINGS_TYPE.Channel_Open]: '채널 열기',
  [RINGS_TYPE.Contemplation]: '명상',
  [RINGS_TYPE.Crystal_Ball]: '크리스털 볼',
  [RINGS_TYPE.Disco]: '디스코',
  [RINGS_TYPE.Door_Bell]: '초인종 소리',
  [RINGS_TYPE.Fairy]: '요정',
  [RINGS_TYPE.Fast_Bells]: '빠른 벨소리',
  [RINGS_TYPE.High_Gong]: '고음 징',
  [RINGS_TYPE.Immersion]: '몰입',
  [RINGS_TYPE.Indeed]: '정말',
  [RINGS_TYPE.Lazy_Day]: '레이지 데이',
  [RINGS_TYPE.Neural_Funk]: '뉴럴 펑크',
  [RINGS_TYPE.Nice]: '좋음',
  [RINGS_TYPE.Ring]: '벨소리',
  [RINGS_TYPE.Ringing_Bells]: '울리는 종',
  [RINGS_TYPE.Simple]: '단순',
  [RINGS_TYPE.Soothing]: '기분을 안정시키는 소리',
  [RINGS_TYPE.Sunshine]: '햇살',
  [RINGS_TYPE.Off]: '끄기',
  add: '추가',
  delete: '삭제',
  play: '재생',
  cancel: '취소',
  confirmToDelete: '{name} 벨소리를 삭제하시겠습니까?',
} as const;

// @key: @#@"[RINGS_TYPE.Phone_Ring1]"@#@ @source: @#@"Phone Ring 1"@#@
// @key: @#@"[RINGS_TYPE.Phone_Ring2]"@#@ @source: @#@"Phone Ring 2"@#@
// @key: @#@"[RINGS_TYPE.Acoustic_Dreams]"@#@ @source: @#@"Acoustic Dreams"@#@
// @key: @#@"[RINGS_TYPE.Air_Raid]"@#@ @source: @#@"Air Raid"@#@
// @key: @#@"[RINGS_TYPE.Allusive]"@#@ @source: @#@"Allusive"@#@
// @key: @#@"[RINGS_TYPE.Attention]"@#@ @source: @#@"Attention"@#@
// @key: @#@"[RINGS_TYPE.Blub_Blub]"@#@ @source: @#@"Blub Blub"@#@
// @key: @#@"[RINGS_TYPE.Buzzy]"@#@ @source: @#@"Buzzy"@#@
// @key: @#@"[RINGS_TYPE.Channel_Open]"@#@ @source: @#@"Channel Open"@#@
// @key: @#@"[RINGS_TYPE.Contemplation]"@#@ @source: @#@"Contemplation"@#@
// @key: @#@"[RINGS_TYPE.Crystal_Ball]"@#@ @source: @#@"Crystal Ball"@#@
// @key: @#@"[RINGS_TYPE.Disco]"@#@ @source: @#@"Disco"@#@
// @key: @#@"[RINGS_TYPE.Door_Bell]"@#@ @source: @#@"Door Bell"@#@
// @key: @#@"[RINGS_TYPE.Fairy]"@#@ @source: @#@"Fairy"@#@
// @key: @#@"[RINGS_TYPE.Fast_Bells]"@#@ @source: @#@"Fast Bells"@#@
// @key: @#@"[RINGS_TYPE.High_Gong]"@#@ @source: @#@"High Gong"@#@
// @key: @#@"[RINGS_TYPE.Immersion]"@#@ @source: @#@"Immersion"@#@
// @key: @#@"[RINGS_TYPE.Indeed]"@#@ @source: @#@"Indeed"@#@
// @key: @#@"[RINGS_TYPE.Lazy_Day]"@#@ @source: @#@"Lazy Day"@#@
// @key: @#@"[RINGS_TYPE.Neural_Funk]"@#@ @source: @#@"Neural Funk"@#@
// @key: @#@"[RINGS_TYPE.Nice]"@#@ @source: @#@"Nice"@#@
// @key: @#@"[RINGS_TYPE.Ring]"@#@ @source: @#@"Ring"@#@
// @key: @#@"[RINGS_TYPE.Ringing_Bells]"@#@ @source: @#@"Ringing Bells"@#@
// @key: @#@"[RINGS_TYPE.Simple]"@#@ @source: @#@"Simple"@#@
// @key: @#@"[RINGS_TYPE.Soothing]"@#@ @source: @#@"Soothing"@#@
// @key: @#@"[RINGS_TYPE.Sunshine]"@#@ @source: @#@"Sunshine"@#@
// @key: @#@"[RINGS_TYPE.Off]"@#@ @source: @#@"Off"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"delete"@#@ @source: @#@"Delete"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirmToDelete"@#@ @source: @#@"Delete {name}?"@#@
